import {
  ServiceProviderDef,
  ServiceProviderKey,
} from 'types/settings/serviceConnectionTypes';

export const SERVICE_PROVIDERS: ServiceProviderDef[] = [
  {
    key: 'beam',
    name: 'Beam',
    subtitleKey: 'Beam',
    // subtitleKey: '',
    descriptionKey:
      'Beam is a payment platform that lets you receive payments via QR Code, cards, installments and more, with automatic reconciliation.',
    registerUrl: 'https://www.beamcheckout.com',
    icon: 'ri-qr-scan-2-line',
    logoSrc: '/assets/logos/beam_logo.svg',
  },
  // {
  //   key: 'qrcode',
  //   name: 'QR Code',
  //   subtitleKey: 'QR Code',
  //   descriptionKey:
  //     'Connect a QR Code payment channel so customers can scan and pay directly.',
  //   icon: 'ri-qr-code-line',
  // },
];

export const SERVICE_PROVIDER_API_NAMES: Record<ServiceProviderKey, string> = {
  beam: 'Beam',
  // qrcode: 'QR Code',
};

// Limit input length for credential fields (merchantId, keyName, apiKey, bankAccountNumber, bankAccountName)
export const CREDENTIAL_MAX_LENGTH = 100;
